{
  "nav": {
    "home": "Acasă",
    "documents": "Documente",
    "properties": "Proprietăți",
    "payments": "Plăți",
    "budget": "Buget",
    "tasks": "Taskuri",
    "investments": "Investiții",
    "finances": "Finanțe",
    "settings": "Setări",
    "configure": "Configurare",
    "logout": "Deconectare",
    "closeMenu": "Închide meniu",
    "collapseSidebar": "Ascunde bara laterală",
    "expandSidebar": "Afișează bara laterală",
    "documentQueue": "Coadă documente",
    "family": "Familie",
    "career": "Carieră",
    "tools": "Instrumente",
    "aiChat": "Chat AI",
    "knowledge": "Cunoștințe",
    "bundles": "Pachete",
    "utilityMigrations": "Migrări utilități",
    "hoaCharges": "Cheltuieli asociație",
    "estatePlanner": "Planificator patrimonial",
    "ghostfolio": "Ghostfolio",
    "appName": "FamilyHub",
    "restrictedAccess": "acces restricționat"
  },
  "errors": {
    "forbidden": "Nu ai permisiunea pentru această acțiune.",
    "careerReadOnly": "Profilul este doar în citire: îl poți vedea, dar nu îl poți modifica.",
    "notFound": "Resursa nu a fost găsită.",
    "server": "Eroare de server. Încearcă din nou.",
    "connection": "Eroare de conexiune. Verifică internetul.",
    "noAccessTitle": "Acces refuzat",
    "noAccessDescription": "Nu ai permisiunea să vezi această pagină. Cere unui administrator dacă ai nevoie de acces."
  },
  "aiChat": {
    "title": "Chat AI",
    "checking": "Se verifică starea AI...",
    "ready": "AI este pregătit",
    "open": "Deschide chat AI",
    "unavailable": "Serviciul AI nu este disponibil",
    "unavailableHint": "Motorul AI nu a putut porni în 30 de secunde. Poate fi ocupat sau offline.",
    "retry": "Reîncearcă",
    "openAnyway": "Deschide WebUI ↗",
    "starting": "Se pornește motorul AI... La prima încărcare poate dura câteva minute.",
    "startingHint": "Modelul AI se încarcă în memoria GPU. Vei fi redirecționat automat când este gata."
  },
  "bundles": {
    "sidebarHint": "Grupează documentele înrudite în pachete pentru organizare ușoară",
    "filterPlaceholder": "Filtrează pachetele…",
    "empty": "Niciun pachet încă.",
    "createFirst": "Creează primul pachet"
  },
  "auth": {
    "login": "Autentificare",
    "logout": "Deconectare",
    "username": "Username",
    "password": "Parolă",
    "welcome": "Bine ai venit!",
    "loginTitle": "Autentificare",
    "loginSubtitle": "Intră în contul tău FamilyHub",
    "loginButton": "Autentificare",
    "loggingIn": "Se autentifică...",
    "usernameRequired": "Username-ul este obligatoriu",
    "passwordRequired": "Parola este obligatorie",
    "invalidCredentials": "Username sau parolă incorectă",
    "showPassword": "Arată parola",
    "hidePassword": "Ascunde parola",
    "tagline": "Managementul familiei, simplificat",
    "copyright": "© 2024 FamilyHub. Toate drepturile rezervate.",
    "wakingUp": "Backend-ul se trezește…",
    "backendUnavailableTitle": "Backend indisponibil",
    "backendUnavailableMessage": "Nu am putut contacta serverul. Sesiunea ta este încă salvată — încearcă din nou în câteva momente.",
    "backendUnavailableRetry": "Reîncearcă",
    "throttled": "Prea multe încercări. Așteaptă câteva minute și încearcă din nou."
  },
  "login": {
    "title": "Autentificare",
    "subtitle": "Intră în contul tău FamilyHub",
    "email": "Email",
    "password": "Parolă",
    "submit": "Autentificare",
    "loading": "Se autentifică...",
    "welcome": "Bine ai venit!",
    "invalidEmail": "Adresă de email invalidă",
    "passwordRequired": "Parola este obligatorie",
    "wrongCredentials": "Email sau parolă incorectă",
    "securityCheckFailed": "Verificarea de securitate a eșuat. Reîncarcă pagina și încearcă din nou.",
    "serviceStarting": "Serviciul pornește. Așteptați câteva minute, apoi încercați din nou să vă autentificați."
  },
  "passwordReset": {
    "forgotLink": "Ai uitat parola?",
    "forgotTitle": "Resetare parolă",
    "forgotSubtitle": "Introdu adresa de email și îți vom trimite un link de resetare.",
    "submit": "Trimite linkul",
    "sending": "Se trimite...",
    "confirmation": "Dacă există un cont pentru acest email, vei primi un link de resetare.",
    "backToLogin": "Înapoi la autentificare",
    "resetTitle": "Parolă nouă",
    "resetSubtitle": "Alege o parolă nouă pentru contul tău.",
    "newPassword": "Parola nouă",
    "confirmPassword": "Confirmă parola",
    "passwordsMismatch": "Parolele nu coincid",
    "minLength": "Parola trebuie să aibă cel puțin {{count}} caractere",
    "minLengthHint": "Minim {{count}} caractere",
    "submitReset": "Salvează parola",
    "resetting": "Se salvează...",
    "successTitle": "Parolă actualizată",
    "successMessage": "Parola ta a fost schimbată. Te poți autentifica cu noua parolă.",
    "invalidTokenTitle": "Link expirat",
    "invalidTokenMessage": "Linkul de resetare nu este valid sau a expirat.",
    "tokenMissing": "Linkul de resetare este incomplet. Solicită un link nou.",
    "requestNewLink": "Solicită un link nou",
    "unavailable": "Resetarea parolei nu este disponibilă momentan. Contactează administratorul.",
    "confirmError": "Nu am putut reseta parola. Încearcă din nou sau solicită un link nou."
  },
  "settings": {
    "title": "Setări",
    "subtitle": "Gestionează contul și preferințele tale",
    "tabs": {
      "profile": "Profil",
      "security": "Securitate",
      "apiAccess": "Acces API",
      "notifications": "Notificări",
      "appearance": "Aspect",
      "integrations": "Integrări",
      "users": "Utilizatori",
      "backup": "Backup",
      "accessRequests": "Cereri de acces"
    },
    "profile": {
      "title": "Informații profil",
      "description": "Actualizează informațiile tale personale",
      "firstName": "Prenume",
      "lastName": "Nume",
      "email": "Email",
      "emailVerified": "Email verificat",
      "emailNotVerified": "Email neverificat",
      "phone": "Telefon",
      "username": "Username",
      "usernamePlaceholder": "Username opțional pentru autentificare",
      "save": "Salvează",
      "saved": "Profil actualizat",
      "error": "Eroare la actualizarea profilului",
      "changePhoto": "Schimbă fotografia",
      "removePhoto": "Șterge",
      "avatarUploaded": "Fotografia de profil a fost actualizată",
      "avatarRemoved": "Fotografia de profil a fost ștearsă",
      "avatarError": "Eroare la actualizarea fotografiei",
      "avatarInvalidType": "Doar fișiere JPEG, PNG, WebP și GIF sunt permise",
      "avatarTooLarge": "Fișierul trebuie să fie sub 5MB"
    },
    "security": {
      "title": "Schimbă parola",
      "description": "Asigură-te că folosești o parolă puternică",
      "currentPassword": "Parola curentă",
      "newPassword": "Parola nouă",
      "confirmPassword": "Confirmă parola nouă",
      "submit": "Schimbă parola",
      "mismatch": "Parolele nu coincid",
      "success": "Parolă schimbată cu succes",
      "error": "Eroare la schimbarea parolei"
    },
    "notifications": {
      "title": "Preferințe notificări",
      "description": "Alege cum vrei să primești notificări",
      "emailPayments": "Notificări email pentru plăți",
      "emailPaymentsDesc": "Primește email când o plată este înregistrată sau restantă",
      "emailReminders": "Notificări email pentru reminder-e",
      "emailRemindersDesc": "Primește email pentru reminder-ele programate",
      "emailDocuments": "Notificări email pentru documente",
      "emailDocumentsDesc": "Primește email când un document nou este adăugat",
      "pushPayments": "Notificări push",
      "pushPaymentsDesc": "Primește notificări push în browser",
      "telegram": "Telegram",
      "telegramDesc": "Alerte prin @FamilyHubAssistantManagerBot"
    },
    "appearance": {
      "title": "Aspect și limbă",
      "description": "Personalizează experiența ta",
      "theme": "Temă",
      "themeLight": "Deschisă",
      "themeDark": "Întunecată",
      "themeSystem": "Sistem",
      "language": "Limbă",
      "dateFormat": "Format dată",
      "timezone": "Fus orar",
      "save": "Salvează",
      "saved": "Setări aspect salvate",
      "error": "Nu am putut salva preferința de limbă"
    },
    "integrations": {
      "title": "Integrări externe",
      "description": "Conectează servicii externe pentru funcționalități adiționale",
      "connected": "Conectat",
      "connect": "Conectează",
      "disconnect": "Deconectează",
      "googleDrive": "Sincronizează documentele cu Google Drive",
      "email": "Configurează trimiterea de email-uri"
    },
    "users": {
      "title": "Gestionare utilizatori",
      "description": "Administrează utilizatorii și permisiunile",
      "noPermission": "Nu ai permisiunea de a gestiona utilizatori"
    },
    "apiAccess": {
      "title": "Chei API",
      "description": "Creează și gestionează chei API pentru OpenWebUI, clienți MCP și ChatGPT Actions",
      "createKey": "Creează cheie API",
      "empty": "Nicio cheie API încă. Creează una pentru a conecta instrumente externe.",
      "revoke": "Revocă",
      "revoked": "Cheia API a fost revocată",
      "revokeError": "Revocarea cheii API a eșuat",
      "editKey": "Editează permisiunile cheii API",
      "editScopes": "Editează permisiuni",
      "saveScopes": "Salvează permisiuni",
      "updated": "Permisiunile cheii API au fost actualizate",
      "updateError": "Actualizarea permisiunilor cheii API a eșuat",
      "createError": "Crearea cheii API a eșuat",
      "confirmRevoke": "Revoci cheia API \"{{name}}\"? Acțiunea este ireversibilă.",
      "neverUsed": "Niciodată",
      "nameRequired": "Numele cheii este obligatoriu",
      "serviceAdminOnly": "Doar administratorii pot crea chei de serviciu",
      "namePlaceholder": "ex. Asistent OpenWebUI",
      "expiryHint": "Lasă gol pentru fără expirare",
      "permissionMode": "Configurare permisiuni",
      "usePreset": "Folosește un preset",
      "customPermissions": "Permisiuni personalizate",
      "selectPreset": "Selectează un preset…",
      "allowAll": "Acces complet (doar admin)",
      "permissionTree": "Permisiuni pe categorii",
      "catalogEmpty": "Catalogul de permisiuni nu este disponibil încă.",
      "mcpTools": "Instrumente MCP",
      "mcpToolsEmpty": "Niciun instrument MCP în catalog.",
      "oneTimeWarning": "Copiază cheia acum — nu va mai fi afișată.",
      "yourKey": "Cheie API",
      "copied": "Copiat în clipboard",
      "copySnippet": "Copiază",
      "done": "Gata",
      "back": "Înapoi",
      "next": "Continuă",
      "keyTypeUserHint": "Acționează ca utilizatorul selectat; permisiunile sunt limitate de rolul său.",
      "keyTypeServiceHint": "Cheie de automatizare independentă cu propria listă de permisiuni.",
      "columns": {
        "name": "Nume",
        "type": "Tip",
        "prefix": "Prefix",
        "scopes": "Domenii",
        "lastUsed": "Ultima utilizare"
      },
      "keyTypes": {
        "user": "Utilizator",
        "service": "Serviciu"
      },
      "fields": {
        "keyType": "Tip cheie",
        "name": "Nume",
        "owner": "Utilizator proprietar",
        "expiry": "Expiră la",
        "preset": "Preset"
      },
      "access": {
        "read": "Citire",
        "write": "Scriere"
      },
      "wizard": {
        "step3Title": "Cheia ta API nouă",
        "stepOf": "Pasul {{step}} din {{total}}"
      },
      "snippets": {
        "openwebui": "Mediu OpenWebUI",
        "mcp": "Config MCP (Cursor / Claude Desktop)",
        "chatgpt": "ChatGPT Actions / MCP la distanță"
      }
    }
  },
  "notifications": {
    "empty": "Nu ai notificări noi.",
    "markAllRead": "Marchează tot ca citit",
    "unreadCount_zero": "Nicio notificare necitită",
    "unreadCount_one": "1 notificare necitită",
    "unreadCount_other": "{{count}} notificări necitite"
  },
  "common": {
    "loading": "Se încarcă...",
    "error": "Eroare",
    "success": "Succes",
    "cancel": "Anulează",
    "delete": "Șterge",
    "edit": "Editează",
    "add": "Adaugă",
    "search": "Caută",
    "filter": "Filtrează",
    "actions": "Acțiuni",
    "notifications": "Notificări",
    "close": "Închide",
    "allCategories": "Toate categoriile",
    "selectPeriod": "Selectează perioada",
    "selectBank": "Selectează banca",
    "configuration": "Configurare",
    "userMenu": "Meniu utilizator",
    "openMenu": "Deschide meniul",
    "logout": "Deconectare",
    "save": "Salvează",
    "saving": "Se salvează...",
    "all": "Toate",
    "assign": "Atribuie",
    "create": "Creează",
    "import": "Importă",
    "move": "Mută",
    "overdue": "Întârziat",
    "properties": "Proprietăți",
    "remove": "Elimină",
    "unknown": "Necunoscut",
    "yes": "Da",
    "loadError": "Datele nu au putut fi încărcate. Încercați din nou.",
    "retry": "Reîncearcă"
  },
  "accessRequests": {
    "noAccessMessage": "Nu ai acces la această secțiune.",
    "adminOnlyNote": "Doar administratorul gospodăriei poate activa această secțiune. Contactează administratorul dacă ai nevoie de acces.",
    "requestButton": "Solicită acces",
    "pendingLabel": "Cerere în așteptare",
    "cancelRequest": "Anulează cererea",
    "cancelRequestAria": "Anulează cererea de acces",
    "approve": "Aprobă",
    "deny": "Respinge",
    "approveAria": "Aprobă cererea {{id}}",
    "denyAria": "Respinge cererea {{id}}",
    "modules": {
      "apartments": "Apartamente",
      "payments": "Plăți",
      "budget": "Buget",
      "documents": "Documente",
      "tasks": "Taskuri",
      "reminders": "Reminder-e",
      "knowledge": "Knowledge",
      "family": "Familie",
      "ai_chat": "Asistent AI",
      "integrations": "Integrări"
    },
    "target": {
      "building": "Clădire #{{id}}"
    },
    "status": {
      "pending": "În așteptare",
      "approved": "Aprobată",
      "denied": "Respinsă",
      "cancelled": "Anulată"
    },
    "dialog": {
      "title": "Solicită acces",
      "description": "Trimite o cerere administratorului gospodăriei. Poți adăuga un mesaj opțional.",
      "messageLabel": "Mesaj (opțional)",
      "messagePlaceholder": "De ce ai nevoie de acces?",
      "messageHint": "Maximum 500 caractere.",
      "requiresNote": "La aprobare vei primi și: {{grants}}."
    },
    "requiredGrants": {
      "apartments_view_all": "acces de citire (doar vizualizare) la apartamente"
    },
    "toast": {
      "created": "Cererea de acces a fost trimisă.",
      "throttled": "Ai trimis prea multe cereri. Încearcă din nou mai târziu.",
      "createError": "Nu am putut trimite cererea de acces.",
      "duplicatePending": "Există deja o cerere în așteptare pentru această secțiune.",
      "notPending": "Această cerere nu mai este în așteptare (a fost deja procesată).",
      "familyCannotDecide": "Doar administratorul gospodăriei poate aproba sau respinge cereri de acces.",
      "cancelled": "Cererea a fost anulată.",
      "cancelError": "Nu am putut anula cererea.",
      "approved": "Cererea a fost aprobată.",
      "denied": "Cererea a fost respinsă.",
      "decideError": "Nu am putut actualiza cererea."
    },
    "settings": {
      "pendingTitle": "Cereri de acces în așteptare",
      "pendingDescription": "Aprobă sau respinge cererile viewerilor din gospodărie.",
      "noPending": "Nu există cereri în așteptare.",
      "mineTitle": "Cererile mele",
      "mineDescription": "Statusul cererilor de acces trimise de tine.",
      "noMine": "Nu ai trimis încă nicio cerere.",
      "pendingBadge": "{{count}} cereri de acces în așteptare"
    }
  },
  "dashboard": {
    "title": "Tablou de bord",
    "subtitle": "Privire de ansamblu asupra activităților familiei",
    "greeting": "Bună ziua! 👋",
    "greetingName": "Bună ziua, {{name}}! 👋",
    "summary": "Iată ce se întâmplă cu familia ta astăzi",
    "totalDocuments": "Total documente",
    "activeContracts": "Contracte active",
    "pendingPayments": "Plăți în așteptare",
    "overduePayments": "Plăți restante",
    "recentActivity": "Activitate recentă",
    "upcomingPayments": "Plăți viitoare",
    "upcomingTasks": "Taskuri viitoare",
    "quickStats": "Statistici rapide",
    "currentBudget": "Buget luna curentă",
    "income": "Venituri",
    "expenses": "Cheltuieli",
    "balance": "Balanță",
    "noRecentActivity": "Nicio activitate recentă",
    "noUpcomingPayments": "Nicio plată viitoare",
    "apartments": {
      "total": "Total apartamente",
      "occupied": "Ocupate",
      "vacant": "Libere",
      "overdue": "Restanțe"
    },
    "activities": {
      "documentAdded": "Document nou adăugat",
      "paymentRecorded": "Plată înregistrată",
      "taskCompleted": "Task finalizat"
    }
  },
  "budget": {
    "title": "Buget",
    "subtitle": "Urmărește veniturile și cheltuielile familiei",
    "importCSV": "Import CSV",
    "addTransaction": "Adaugă tranzacție",
    "recentTransactions": "Tranzacții recente",
    "noTransactions": "Nicio tranzacție găsită",
    "importFromCSV": "Import din CSV",
    "importTransactionsCSV": "Import tranzacții din CSV",
    "bank": "Bancă",
    "csvFile": "Fișier CSV",
    "lastWeek": "Ultima săptămână",
    "currentMonth": "Luna curentă",
    "last3Months": "Ultimele 3 luni",
    "currentYear": "Anul curent",
    "comparedToLastMonth": "față de luna trecută",
    "uncategorized": "Necategorizat",
    "importSuccess": "{{count}} tranzacții importate cu succes",
    "importError": "Eroare la importul tranzacțiilor",
    "selectBank": "Selectează banca",
    "importing": "Se importă...",
    "import": "Import",
    "incomeThisMonth": "Venituri luna aceasta",
    "expensesThisMonth": "Cheltuieli luna aceasta",
    "totalAccountBalance": "Total sold conturi",
    "searchPlaceholder": "Caută tranzacții...",
    "filterByType": "Filtrează după tip",
    "allTypes": "Toate tipurile",
    "income": "Venituri",
    "expenses": "Cheltuieli",
    "filterByCategory": "Filtrează după categorie",
    "allCategories": "Toate categoriile",
    "noTransactionsFound": "Nicio tranzacție găsită",
    "accounts": "Conturi",
    "bonds": {
      "annualLumpSum": "Sumă forfetară anuală",
      "fidelisTitle": "Februarie — Fidelis (R3202A)",
      "netYr": "Net/an:",
      "tbiScheduleTitle": "Depozite TBI — Calendar scadențe",
      "tezaurTitle": "Noiembrie — Obligațiuni Tezaur"
    },
    "fiveYear": {
      "allFiguresNote": "Toate cifrele în RON · Apreciere: {{pct}}%/an",
      "appreciation": "Apreciere",
      "base": "Bază (10 luni)",
      "best": "Optim (12 luni)",
      "bondCoupon": "Cupon obligațiuni",
      "expenses": "Cheltuieli",
      "fiveYrGrowth": "Creștere 5 ani",
      "netWorth": "Avere netă",
      "netWorth2026": "Avere netă 2026",
      "netWorth2030": "Avere netă 2030",
      "occupied": "ocupat",
      "owner": "Proprietar",
      "property": "Proprietate",
      "propertyVal": "Val. proprietate",
      "propertyValues": "Valori proprietăți — {{year}}",
      "rentalNet": "Chirie netă",
      "scenario": "Scenariu",
      "surplus": "Surplus",
      "totalSurplus": "Surplus total",
      "value2026": "Valoare 2026",
      "worst": "Pesimist (8 luni)",
      "year": "An",
      "yearByYear": "Sumar an cu an"
    },
    "imminentAlert": "IMINENT — {{symbol}} scadent {{maturity}}",
    "imminentAlertDesc": "Principal: {{principal}}. Verificați lichiditatea și opțiunile de reinvestire.",
    "monthly": {
      "beforeTax": "Înainte de impozit · 10% reținere la sursă",
      "belowFloor": "✗ Sub pragul minim",
      "bestTerm": "Cel mai bun termen",
      "currentLiquidCash": "Cash lichid curent",
      "deployableSurplus": "Surplus disponibil",
      "depositLadder": "Fidelis R3202A feb. 2027 — Scara depozitelor",
      "estNet6m": "Est. net / 6L",
      "liquidCash": "Cash lichid",
      "liquidCashDesc": "Introduceți totalul cash-ului lichid disponibil (economii și cont curent) în RON.",
      "liquidityChecklist": "Verificare lichiditate",
      "liquidityFloor": "Prag lichiditate (3×chelt.)",
      "liquidityOk": "✓ Lichiditate OK",
      "maturity": "Scadență",
      "netInterest": "Dobândă netă",
      "principal": "Principal",
      "rate": "Rată",
      "rateYear": "Rată ({{year}})",
      "suggestedPrincipal": "Principal sugerat",
      "tbiRatesForecast": "Previziune rate TBI (2026–2030)",
      "tbiRecommendation": "Recomandare depozit TBI",
      "tranche": "Tranșă"
    },
    "occupancy": {
      "desc": "Media lunilor închiriate pe an (trageți pentru a recalcula)",
      "title": "Estimare ocupare"
    },
    "scenario": {
      "annual": "Anual",
      "baseline": "(referință)",
      "bondsEquiv": "Echiv. obligațiuni",
      "expenses": "Cheltuieli",
      "months": "Luni",
      "pension": "Pensie",
      "rentalNet": "Chirie netă",
      "subtitle": "Toate cifrele în RON/lună · Obligațiunile tratate ca echivalent lunar",
      "surplus": "Surplus",
      "title": "Sensibilitate ocupare (8–12 luni)",
      "totalIncome": "Venit total"
    },
    "stats": {
      "annualSurplus": "Surplus anual",
      "bondsEquiv": "Echiv. obligațiuni / lună",
      "bufferNeeded": "Buffer necesar",
      "expenses": "Cheltuieli / lună",
      "netSurplus": "Surplus net / lună",
      "noneOk": "Niciunul ✓",
      "pension": "Pensie / lună",
      "rentalNet": "Chirie netă / lună",
      "totalIncome": "Venit total / lună"
    },
    "tabs": {
      "fiveYear": "Plan 5 ani",
      "monthly": "Manager lunar",
      "overview": "Prezentare generală"
    },
    "tbi": {
      "imminent": "IMINENT",
      "maturity": "Scadență",
      "netPerYear": "Net/an",
      "rate": "Rată",
      "soon": "Curând"
    },
    "totals": {
      "grossYr": "Brut / an",
      "monthlyEquiv": "Echivalent lunar",
      "netYr": "Net / an",
      "title": "Totaluri portofoliu obligațiuni"
    }
  },
  "payments": {
    "title": "Plăți",
    "fieldTitle": "Titlu",
    "subtitle": "Gestionează plățile de chirie și utilități",
    "addPayment": "Adaugă plată",
    "recordPayment": "Înregistrează plată",
    "filterByStatus": "Filtrează după status",
    "filterByType": "Filtrează după tip",
    "allStatuses": "Toate statusurile",
    "allTypes": "Toate tipurile",
    "noPayments": "Nicio plată găsită",
    "noPaymentsFound": "Nicio plată găsită cu aceste filtre",
    "searchPlaceholder": "Caută plăți...",
    "pending": "În așteptare",
    "partial": "Parțial",
    "paid": "Plătit",
    "overdue": "Restant",
    "cancelled": "Anulat",
    "rent": "Chirie",
    "utilities": "Utilități",
    "deposit": "Garanție",
    "maintenance": "Întreținere",
    "other": "Altele",
    "paidAmount": "Plătit:",
    "viewDetails": "Vezi detalii plată",
    "markPaid": "Marchează plătit",
    "markedPaidSuccess": "Plată marcată ca plătită",
    "updateError": "Eroare la actualizarea plății",
    "sendReminder": "Trimite memento",
    "reminderSent": "Memento trimis",
    "reminderError": "Eroare la trimiterea memento-ului",
    "totalPayments": "Total plăți",
    "collectedThisMonth": "Colectat luna aceasta",
    "payment": "Plată",
    "tenant": "Chiriaș",
    "apartment": "Apartament",
    "type": "Tip",
    "amount": "Sumă",
    "dueDate": "Dată scadentă",
    "paidDate": "Data Plății",
    "status": "Status",
    "actions": "Acțiuni"
  },
  "tasks": {
    "title": "Taskuri",
    "subtitle": "Gestionează taskurile familiei",
    "addTask": "Adaugă task",
    "newTask": "Task nou",
    "noTasks": "Niciun task",
    "taskOptions": "Opțiuni task",
    "filterByProject": "Filtrează după proiect",
    "filterByBuilding": "Filtrează după clădire",
    "filterByApartment": "Filtrează după apartament",
    "allProjects": "Toate proiectele",
    "allBuildings": "Toate clădirile",
    "allApartments": "Toate apartamentele",
    "allPriorities": "Toate prioritățile",
    "allTypes": "Toate tipurile",
    "searchPlaceholder": "Caută taskuri…",
    "clearFilters": "Șterge filtrele",
    "labelFilterPlaceholder": "Etichetă",
    "showCancelled": "Afișează anulate",
    "boardView": "Tablou",
    "listView": "Listă",
    "viewToggle": "Mod vizualizare",
    "boardRegion": "Tablou de taskuri",
    "listRegion": "Lista de taskuri",
    "listCount": "{{count}} taskuri",
    "loadMore": "Încarcă mai multe",
    "openTask": "Deschide task: {{title}}",
    "dragHandle": "Trage pentru reordonare",
    "quickAddLabel": "Titlu task rapid",
    "quickAddPlaceholder": "Titlul taskului, Enter…",
    "updateError": "Eroare la actualizarea taskului",
    "todo": "De făcut",
    "inProgress": "În progres",
    "waiting": "În așteptare",
    "done": "Finalizat",
    "cancelled": "Anulat",
    "low": "Scăzut",
    "medium": "Mediu",
    "high": "Ridicat",
    "typePayment": "Plată",
    "typeMedical": "Medical",
    "typeRepair": "Reparație",
    "typeDocument": "Document",
    "typeContact": "Contact",
    "typeMeeting": "Întâlnire",
    "typeOther": "Altele",
    "typeGeneral": "General",
    "typeInspection": "Inspecție",
    "typePurchase": "Achiziție",
    "newEntry": "Task nou / Intrare mentenanță",
    "titleLabel": "Titlu",
    "titleRequired": "Titlu *",
    "titlePlaceholder": "Titlul taskului...",
    "descriptionPlaceholder": "Descriere opțională...",
    "descriptionLabel": "Descriere",
    "description": "Descriere",
    "statusLabel": "Stare",
    "status": "Stare",
    "typeLabel": "Tip",
    "type": "Tip",
    "priorityLabel": "Prioritate",
    "priority": "Prioritate",
    "dueDateLabel": "Dată scadentă",
    "dueDate": "Dată scadentă",
    "budgetLabel": "Buget (€)",
    "budget": "Buget",
    "project": "Proiect",
    "noProject": "Fără proiect",
    "building": "Clădire",
    "noBuilding": "Neasociat cu o clădire",
    "apartment": "Apartament",
    "noApartment": "Fără apartament",
    "selectBuildingFirst": "Selectați mai întâi o clădire",
    "labels": "Etichete",
    "labelsPlaceholder": "Adaugă etichetă…",
    "checklist": "Listă de verificare",
    "noChecklist": "Niciun element în listă",
    "addChecklistPlaceholder": "Adaugă element…",
    "comments": "Comentarii",
    "noComments": "Niciun comentariu",
    "addCommentPlaceholder": "Scrie un comentariu…",
    "postComment": "Postează",
    "linkedIdentities": "Persoane asociate",
    "dependencies": "Dependențe",
    "blockedBy": "Blocat de {{title}}",
    "sourceKey": "Cheie sursă",
    "loadingTask": "Se încarcă taskul…",
    "loadTaskError": "Taskul nu a putut fi încărcat",
    "taskRef": "Task #{{id}}",
    "unknownAuthor": "Necunoscut",
    "commentError": "Comentariul nu a putut fi adăugat",
    "checklistError": "Lista nu a putut fi actualizată",
    "assignee": "Responsabil",
    "createButton": "Crează",
    "addEntryButton": "Adaugă intrare",
    "dueLabel": "Scadent {{date}}",
    "overdue": "Restant",
    "taskCreated": "Task creat",
    "taskCreatedSuccess": "Task creat",
    "taskCreateError": "Eroare la crearea taskului",
    "createError": "Eroare la crearea taskului",
    "editTask": "Editează task",
    "taskUpdated": "Task actualizat",
    "taskDeleted": "Task șters",
    "deleteError": "Eroare la ștergerea taskului",
    "confirmDelete": "Șterge task?",
    "confirmDeleteMessage": "Sigur doriți să ștergeți \"{{title}}\"? Această acțiune nu poate fi anulată."
  },
  "properties": {
    "title": "Proprietăți",
    "subtitle": "Gestionează clădiri, apartamente și chiriași",
    "addBuilding": "Adaugă clădire",
    "addApartment": "Adaugă apartament",
    "addTenant": "Adaugă chiriaș",
    "buildings": "Clădiri",
    "apartments": "Apartamente",
    "tenants": "Chiriași",
    "editApartment": "Editează apartament",
    "editTenant": "Editează chiriaș",
    "deleteTenant": "Șterge chiriaș",
    "tenantDeleted": "Chiriaș șters",
    "tenantDeleteError": "Eroare la ștergerea chiriașului",
    "confirmDeleteTenant": "Ești sigur că vrei să ștergi acest chiriaș?",
    "noBuildings": "Nicio clădire",
    "addFirstBuilding": "Adaugă prima clădire pentru a începe",
    "allBuildings": "Toate clădirile",
    "noApartments": "Niciun apartament",
    "noTenants": "Niciun chiriaș",
    "surface": "Suprafață",
    "rooms": "Camere",
    "rent": "Chirie",
    "occupied": "Ocupat",
    "vacant": "Liber",
    "bills": "Facturi",
    "addBill": "Adaugă factură",
    "noBills": "Nicio factură înregistrată",
    "groupedByBuilding": "Apartamente grupate pe imobil",
    "suggestedDocuments": "Documente Sugerate",
    "viewAllDocs": "Vezi toate în Documente",
    "archiveApartment": "Arhivează apartament",
    "unarchiveApartment": "Restaurează apartament",
    "archived": "Arhivat",
    "showArchived": "Arată arhivate",
    "hideArchived": "Ascunde arhivate",
    "archiveSuccess": "Apartament arhivat",
    "unarchiveSuccess": "Apartament restaurat",
    "building": "Clădire",
    "selectBuilding": "Selectează clădire",
    "noBuildingsYet": "Niciun imobil",
    "apartmentName": "Denumire apartament",
    "apartmentNamePlaceholder": "ex. Ap. 3",
    "floor": "Etaj",
    "bathrooms": "Băi",
    "status": "Status",
    "maintenance": "Mentenanță",
    "reserved": "Rezervat",
    "contractType": "Tip contract",
    "contractRental": "Chirie",
    "contractComodat": "Comodat",
    "contractAirbnb": "Airbnb",
    "contractOther": "Altul",
    "monthlyRent": "Chirie lunară",
    "deposit": "Garanție",
    "rentDueDay": "Zi scadentă chirie",
    "hasParking": "Parcare",
    "hasStorage": "Debara",
    "isFurnished": "Mobilat",
    "notes": "Note",
    "notesPlaceholder": "Note suplimentare...",
    "buildingRequired": "Selectează o clădire",
    "createBuilding": "Crează clădire",
    "buildingCreated": "Clădire adăugată",
    "buildingSaveError": "Eroare la salvare clădire",
    "buildingNamePlaceholder": "de ex. Tineretului 31A",
    "address": "Adresă",
    "city": "Oraș",
    "nameRequired": "Numele este obligatoriu",
    "apartmentCreated": "Apartament adăugat cu succes",
    "apartmentUpdated": "Apartament actualizat",
    "apartmentSaveError": "Eroare la salvare apartament",
    "firstName": "Prenume",
    "lastName": "Nume",
    "phone": "Telefon",
    "email": "Email",
    "apartment": "Apartament",
    "noApartmentAssigned": "Fără apartament alocat",
    "moveInDate": "Data mutare",
    "contractEnd": "Sfârsit contract",
    "cnp": "CNP",
    "cnpPlaceholder": "CNP 13 cifre",
    "permanentAddress": "Adresă permanentă",
    "tenantCreated": "Chiriaș adăugat cu succes",
    "tenantUpdated": "Chiriaș actualizat",
    "tenantSaveError": "Eroare la salvare chiriaș",
    "archiveError": "Eroare la arhivare apartament",
    "addFirstApartment": "Adaugă primul apartament",
    "viewDoc": "Vizualizează",
    "addFromDoc": "Adaugă apartament",
    "addTenantFromDoc": "Adaugă chiriaș",
    "fillFromDocument": "Completeaza din document",
    "searchDocuments": "Cauta documente...",
    "noDocsFound": "Niciun document gasit",
    "noExtractedData": "Nu s-au extras date",
    "useProfile": "Foloseste",
    "tabEstate": "Administrare Imobile",
    "tabAdmin": "Administrare Entități",
    "buildingInfo": "Informații clădire",
    "county": "Județ",
    "floors": "Etaje",
    "yearBuilt": "An construcție",
    "parkingSpots": "Locuri de parcare",
    "administrator": "Administrator",
    "adminPhone": "Telefon administrator",
    "adminEmail": "Email administrator",
    "noApartmentsYet": "Niciun apartament înregistrat",
    "floorLabel": "Etajul {{floor}}",
    "roomsCount": "{{count}} camere",
    "rentDueBadge": "Chirie scadentă",
    "leavingLabel": "Pleacă",
    "todayLabel": "azi",
    "tomorrowLabel": "mâine",
    "daysLeftShort": "{{count}}z",
    "rentPerMonth": "RON/lună",
    "perMonth": "/lună",
    "statOpenMaintenance": "Mentenanță deschisă",
    "statMaintenanceBudget": "Buget mentenanță",
    "statOpenTasks": "Taskuri deschise",
    "statApartments": "Apartamente",
    "statOccupied": "{{count}} ocupate",
    "statTotal": "{{count}} total",
    "statEstimated": "estimat",
    "buildingNotFound": "Clădire negăsită",
    "backToProperties": "Înapoi la Proprietăți",
    "noMaintenanceEntries": "Nicio intrare de mentenanță pentru această clădire",
    "noTasksForBuilding": "Niciun task pentru această clădire",
    "confirmDeleteFull": "Ștergi \"{{name}}\"? Operațiunea este ireversibilă. Toate contractele și legăturile vor fi eliminate.",
    "confirmDeleteSimple": "Ștergi \"{{name}}\"? Operațiunea este ireversibilă.",
    "aptNameNumber": "Denumire / Număr apartament",
    "aptNamePlaceholder": "de ex. Ap. 3A",
    "surfaceM2": "Suprafață (m²)",
    "currency": "Monedă",
    "editApartmentTitle": "Editează apartament",
    "saveChanges": "Salvează modificările",
    "deletingLabel": "Se șterge…",
    "savingLabel": "Se salvează…",
    "apartmentDeletedError": "Eroare la ștergerea apartamentului",
    "archiveUpdateError": "Eroare la actualizarea apartamentului",
    "tabOverview": "Prezentare generală",
    "tabMaintenanceLabel": "Mentenanță",
    "tabTasksLabel": "Taskuri",
    "allPaid": "Toate plătite ✓",
    "noTextExtracted": "Niciun text extras încă",
    "identityNotFound": "Negăsit",
    "identityRoles": "Roluri"
  },
  "estate": {
    "assignPerson": "Asignează Persoană",
    "role": "Rol",
    "roles": {
      "tenant": "Chiriaș",
      "resident": "Rezident",
      "comodatar": "Comodatar",
      "owner": "Proprietar",
      "comodant": "Comodant",
      "guarantor": "Garant",
      "agent": "Agent",
      "other": "Altul"
    },
    "roleGroupPermanent": "Permanent",
    "roleGroupContractual": "Contractual / Chiriași",
    "startDate": "Data Început",
    "endDate": "Data Sfârșit (opțional)",
    "assignRole": "Asignează Rol",
    "roleAssigned": "Rol asignat cu succes",
    "roleAssignError": "Eroare la asignarea rolului",
    "selectIdentityRequired": "Selectați o persoană sau firmă",
    "since": "din",
    "person": "Persoană / Firmă",
    "noIdentitiesFound": "Nicio entitate găsită",
    "removeRole": "Elimină Rol",
    "removeRoleError": "Eroare la eliminarea rolului",
    "noRoles": "Nicio persoană asignată",
    "assignFirst": "Asignați prima persoană pentru acest apartament"
  },
  "administration": {
    "people": "Persoane",
    "companies": "Firme",
    "bills": "Facturi",
    "noPeople": "Nicio persoană adăugată",
    "noCompanies": "Nicio firmă adăugată",
    "allBills": "Toate"
  },
  "documents": {
    "title": "Documente",
    "subtitle": "Gestionează documentele tale",
    "uploadDocuments": "Încarcă documente",
    "uploadDocument": "Încarcă document",
    "dropFilesHere": "Trage fișierele aici...",
    "supportedFormats": "PDF, imagini sau documente Word",
    "noDocuments": "Niciun document",
    "noDocumentsFiltered": "Niciun document găsit cu aceste filtre",
    "startByUploading": "Începe prin a încărca primul tău document",
    "searchDocuments": "Caută documente...",
    "filterByCategory": "Filtrează după categorie",
    "filterByStatus": "Filtrează după status",
    "allCategories": "Toate categoriile",
    "allStatuses": "Toate statusurile",
    "pending": "În așteptare",
    "processing": "În procesare",
    "processed": "Procesat",
    "failed": "Eroare",
    "showingResults": "Afișare {{count}} din {{total}} documente",
    "paginatedResults": "Rezultate încărcate din lista paginată a backend-ului",
    "arrayResults": "Rezultate încărcate din lista simplă a backend-ului",
    "documentOptions": "Opțiuni document",
    "view": "Vizualizează",
    "preview": "Previzualizare",
    "previewUnavailable": "Previzualizarea nu este disponibilă încă pentru acest tip de fișier.",
    "previewLoadError": "Previzualizarea nu a putut fi încărcată inline. Poți totuși descărca fișierul.",
    "previewReturnedHtml": "URL-ul de previzualizare a returnat pagina aplicației în locul fișierului documentului. Verifică path-ul media sau configurarea proxy-ului.",
    "fileUnavailable": "Acest document nu are momentan un fișier disponibil pentru descărcare.",
    "download": "Descarcă",
    "delete": "Șterge",
    "documentDeleted": "Document șters",
    "documentDeleteError": "Eroare la ștergerea documentului",
    "dragFilesOrClick": "Trage fișierele sau apasă pentru a selecta",
    "close": "Închide",
    "confirmDelete": "Ești sigur că vrei să ștergi acest document?",
    "searchable": "Căutabil",
    "notSearchable": "Necăutabil",
    "notSearchableHelp": "Acest fișier nu are încă text OCR. Poți adăuga etichete ca să fie mai ușor de organizat.",
    "processingIssuesTitle": "Probleme de procesare",
    "ocrFailureTitle": "OCR eșuat",
    "aiLabelingFailureTitle": "Etichetare AI eșuată",
    "uploadedAtLabel": "Încărcat la {{date}}",
    "searchText": "Text extras",
    "labelsTitle": "Etichete / taguri",
    "labelsHelp": "Adaugă etichete separate prin virgulă pentru a ajuta administratorii și utilizatorii să organizeze fișierele necăutabile.",
    "noLabels": "Nu există încă etichete",
    "labelsInput": "Etichete",
    "labelsPlaceholder": "factură, contract, important",
    "saveLabels": "Salvează etichetele",
    "labelsSaved": "Etichetele au fost salvate",
    "labelsError": "Etichetele nu au putut fi salvate",
    "categoryTitle": "Categorie",
    "noCategory": "Fără categorie",
    "saveCategory": "Salvează categoria",
    "categorySaved": "Categoria a fost salvată",
    "categoryError": "Categoria nu a putut fi salvată",
    "suggestedTagsTitle": "Sugestii AI",
    "suggestedTagsHelp": "Revizuiește tagurile sugerate înainte să le promovezi ca etichete aprobate. Sugestiile rămân căutabile atât în română, cât și în engleză.",
    "aiTagBadge": "AI",
    "aiConfidence": "Încredere {{value}}%",
    "approveTag": "Aprobă",
    "rejectTag": "Respinge",
    "tagApproved": "Tagul sugerat a fost aprobat",
    "tagRejected": "Tagul sugerat a fost respins",
    "tagApproveError": "Tagul sugerat nu a putut fi aprobat",
    "tagRejectError": "Tagul sugerat nu a putut fi respins",
    "signatoriesTitle": "Semnatari",
    "signatoriesHelp": "Persoanele care au semnat documentul, extrase în analiza AI.",
    "signatoryRole": "Rol",
    "signatoryEntity": "Entitate",
    "signatoryType": "Tip semnătură",
    "gridView": "Vizualizare grilă",
    "listView": "Vizualizare listă",
    "selectMode": "Selectare",
    "cancelSelection": "Anulează selecția",
    "selectedCount": "{{count}} selectate",
    "selectAllOnPage": "Selectează toate de pe pagină ({{count}})",
    "selectAll": "Selectează tot",
    "deselectAll": "Deselectează tot",
    "bulkAddLabels": "Adaugă etichete",
    "bulkSetCategory": "Setează categoria",
    "bulkCategoryApplied": "Categoria a fost aplicată documentelor selectate",
    "bulkDelete": "Șterge selectate",
    "bulkDeleteConfirm": "Ștergi {{count}} document(e)? Această acțiune nu poate fi anulată.",
    "bulkLabelsApplied": "Etichete aplicate documentelor selectate",
    "bulkDeleteDone": "Documentele selectate au fost șterse",
    "page": "Pagina",
    "pageSize": "Pe pagină",
    "previousPage": "Pagina anterioară",
    "nextPage": "Pagina următoare",
    "queueTitle": "Coadă de procesare",
    "queueDescription": "Monitorizează fişierele care aşteaptă scanarea şi procesarea OCR.",
    "queueActive": "active",
    "queueFailed": "eşuat",
    "queueEmpty": "Coada este goală — niciun fişier în aşteptare",
    "queueEmptyHint": "Documentele noi plasate în dosarul scanerului vor apărea aici.",
    "queueInbox": "În dosarul scanerului",
    "queueWaiting": "Aşteptare",
    "queueProcessing": "Se procesează",
    "queueRecentlyFailed": "Eşuat recent (24 h)",
    "queueLastUpdated": "Actualizat",
    "updated": "Actualizat",
    "reprocess": "Reprocessează",
    "reprocessStarted": "Reprocesare pornită",
    "reprocessError": "Eroare la pornirea reprocessării",
    "relabel": "Re-etichetare",
    "relabelStarted": "Re-etichetare adăugată în coadă",
    "relabelError": "Eroare la adăugarea în coadă",
    "retitle": "Regenerează titlu",
    "retitleStarted": "Regenerare titlu adăugată în coadă",
    "retitleError": "Eroare la regenerarea titlului",
    "confirmApprove": "Confirmă",
    "cancel": "Anulează",
    "bulkRelabel": "Re-etichetare selecție",
    "bulkRelabelDone": "{{count}} document(e) adăugate în coada de re-etichetare",
    "bulkRelabelError": "Eroare la adăugarea în coada de re-etichetare",
    "bulkRetitle": "Regenerează titluri selecție",
    "bulkRetitleDone": "{{count}} document(e) adăugate în coada de regenerare titlu",
    "bulkRetitleError": "Eroare la regenerarea titlurilor",
    "aiLabelingQueue": "Coadă etichetare AI",
    "aiLabelingIdle": "Nicio sarcină de etichetare AI în curs",
    "aiLabelingInProgress": "Etichetare în curs",
    "aiLabelingRecentlyFailed": "Etichetare eșuată (24 h)",
    "aiLabelingStatusInProcessing": "Se etichetează…",
    "aiLabelingStatusCompleted": "Etichetat",
    "aiLabelingStatusFailed": "Etichetare eșuată",
    "aiLabelingStatusNotProcessed": "Neetichetat",
    "filterByAiLabeling": "Filtrează după etichetare AI",
    "allAiStatuses": "Toate statusurile AI",
    "includeAiTags": "Etichete AI",
    "includeAiTagsHelp": "Dezactivat: etichetele sugerate de AI (în așteptare) nu sunt incluse în căutare",
    "aiFeatures": "Etichetare AI și regenerare titlu",
    "aiNotLabeled": "neetichetat",
    "tableView": "Vizualizare tabel",
    "colName": "Nume",
    "colRank": "Scor",
    "colStatus": "Status",
    "colCategory": "Categorie",
    "colType": "Tip",
    "colSize": "Dimensiune",
    "colDate": "Încărcat",
    "filterPlaceholder": "Filtrează…",
    "clearFilters": "Sterge filtrele",
    "tableViewError": "Eroare vizualizare tabel — încearcă să reîncarci pagina.",
    "viewProfiles": "Profiluri de vizualizare",
    "noProfilesYet": "Niciun profil salvat încă",
    "profilesLabel": "Profiluri",
    "resizePanelHint": "Trage pentru a redimensiona panourile",
    "copyPathInline": "Copiază calea",
    "openInExplorer": "Deschide în Explorer",
    "openInExplorerOk": "Se deschide Explorer…",
    "openInExplorerFallback": "Nu s-a putut deschide Explorer automat. Copiază calea manual.",
    "scannerFolder": "Folder scanner",
    "openScannerFolder": "Deschide folderul scanner",
    "scannerFolderTitle": "Folder inbox scanner",
    "scannerFolderDesc": "Pune orice fişier PDF sau imagine în acest folder. Serverul îll va detecta automat şi îll va procesa în biblioteca ta de documente.",
    "containerPath": "Cale container",
    "hostPath": "Cale gazdă (Windows)",
    "clickToEdit": "Click pentru editare",
    "restartRequired": "Cale salvată. Reporniţi stack-ul (docker compose up -d) pentru ca containerul scanner_watcher să monitorizeze noul folder.",
    "folderExists": "Folderul există",
    "folderMissing": "Folderul va fi creat la următoarea activitate",
    "acceptedTypes": "Acceptate",
    "scanNowTitle": "Pune în coadă toate fişierele din inbox pentru procesare imediată",
    "scanning": "Scanare…",
    "scanNow": "Scanează acum",
    "pathCopied": "Calea a fost copiată în clipboard",
    "copyPath": "Copiază calea",
    "scannerSaveError": "Nu s-a putut salva calea scannerului",
    "scanNowEmpty": "Inbox-ul este gol — nimic de procesat.",
    "scanNowQueued": "{{count}} fişier(e) puse în coadă pentru procesare.",
    "scanNowError": "Scanarea a eşuat. Verifică log-urile serverului.",
    "archive": "Arhivează",
    "unarchive": "Restaurează",
    "archiveSuccess": "Document arhivat",
    "unarchiveSuccess": "Document restaurat",
    "showArchived": "Arată arhivate",
    "hideArchived": "Ascunde arhivate"
  },
  "family": {
    "title": "Familie",
    "subtitle": "Gestionează membrii familiei și relațiile dintre ei",
    "members": "Membri",
    "addMember": "Adaugă Membru",
    "noMembers": "Niciun membru al familiei",
    "role": "Rol",
    "owner": "Proprietar",
    "member": "Membru",
    "relation": "Relație",
    "relations": "Relații",
    "tree": "Arbore genealogic",
    "name": "Nume",
    "phone": "Telefon",
    "email": "Email",
    "editMember": "Editează membrul",
    "deleteMember": "Șterge membrul",
    "memberDeleted": "Membrul a fost eliminat",
    "memberDeleteError": "Eroare la eliminarea membrului",
    "confirmDeleteMember": "Elimini acest membru al familiei?",
    "fullName": "Nume complet",
    "fullNamePlaceholder": "ex. Popescu Ion",
    "displayName": "Nume afișat",
    "displayNamePlaceholder": "ex. tata, mama, eu",
    "displayNameHint": "Cod unic folosit în etichetare documente (litere mici, fără spații)",
    "nameAliases": "Variante de nume",
    "nameAliasesPlaceholder": "POPESCU ION, Ion Popescu",
    "nameAliasesHint": "Generate automat din numele complet. Editează pentru aliasuri personalizate OCR.",
    "tenantSuggestions": "Sugestii din chiriași",
    "isOwner": "Proprietar principal",
    "isActive": "Activ",
    "inactive": "Inactiv",
    "alsoKnownAs": "Cunoscut și ca",
    "memberCreated": "Membru adăugat",
    "memberUpdated": "Membru actualizat",
    "memberSaveError": "Eroare la salvare",
    "fullNameRequired": "Numele complet este obligatoriu",
    "displayNameRequired": "Numele afișat este obligatoriu",
    "noRelations": "Nicio relație definită",
    "addRelation": "Adaugă relație",
    "fromMember": "De la",
    "toMember": "Către",
    "relationType": "Tip",
    "relationLabel": "Etichetă (opțional)",
    "selectMember": "Selectează membru",
    "selectType": "Selectează tipul",
    "relationCreated": "Relație adăugată",
    "relationCreateError": "Eroare la adăugarea relației",
    "relationDeleted": "Relație eliminată",
    "relationDeleteError": "Eroare la eliminarea relației",
    "confirmDeleteRelation": "Elimini această relație?",
    "spouse": "Soț/Soție",
    "parent": "Părinte",
    "child": "Copil",
    "sibling": "Frate/Soră",
    "grandparent": "Bunic/Bunică",
    "grandchild": "Nepot/Nepoată",
    "other": "Altul"
  },
  "notFound": {
    "title": "Pagină negăsită",
    "description": "Pagina pe care o cauți nu există sau a fost mutată.",
    "backHome": "Înapoi acasă"
  },
  "identities": {
    "tabLabel": "Identități",
    "addTitle": "Adaugă persoană / firmă",
    "editTitle": "Editează persoană / firmă",
    "name": "Nume complet",
    "firstName": "Prenume",
    "lastName": "Nume familie",
    "type": "Tip",
    "typePerson": "Persoană fizică",
    "typeCompany": "Firmă / Persoană juridică",
    "cnp": "CNP",
    "cui": "CUI (Nr. înregistrare firmă)",
    "phone": "Telefon",
    "email": "Email",
    "address": "Adresă",
    "notes": "Notițe",
    "empty": "Nicio identitate adăugată",
    "created": "Persoană / firmă adăugată",
    "updated": "Actualizat cu succes",
    "deleted": "Șters",
    "saveError": "Eroare la salvare",
    "deleteError": "Eroare la ștergere",
    "confirmDelete": "Ești sigur că vrei să ștergi această intrare?"
  },
  "links": {
    "recommendations": "Recomandări AI",
    "noRecs": "Nicio recomandare încă",
    "noRecsHint": "Apasă «Găsește conexiuni» pentru ca AI să sugereze legături",
    "loadRecs": "Găsește conexiuni",
    "loading": "Se caută conexiuni…",
    "accept": "Acceptă",
    "reject": "Respinge",
    "accepted": "Legătură acceptată",
    "rejected": "Respins",
    "addManual": "Adaugă legătură manual",
    "label": "Relație",
    "confidence": "Grad de certitudine",
    "status": {
      "pending": "În așteptare",
      "accepted": "Confirmat",
      "rejected": "Respins",
      "manual": "Manual"
    },
    "labels": {
      "mentioned_in": "Menționat în",
      "mentions": "Menționează",
      "references_building": "Referă imobil",
      "references_apartment": "Referă apartament",
      "referenced_in": "Referit în",
      "owner_of": "Proprietar al",
      "tenant_at": "Chiriaș la",
      "guarantor_for": "Garant pentru"
    },
    "entityTypes": {
      "identity": "Persoană / Firmă",
      "apartment": "Apartament",
      "building": "Imobil",
      "document": "Document",
      "task": "Sarcină",
      "payment": "Plată"
    },
    "noBuildingsYet": "Niciun imobil — creați unul mai întâi",
    "noBuildings": "Niciun imobil"
  },
  "llm": {
    "offline": "Asistentul AI este offline",
    "requiresLlm": "necesită ca LLM-ul să fie pornit",
    "start": "Pornește LLM",
    "stop": "Oprește LLM",
    "starting": "Se pornește…",
    "stopping": "Se oprește…",
    "startSuccess": "LLM-ul pornește",
    "stopSuccess": "LLM oprit",
    "startError": "Eroare la pornirea LLM",
    "stopError": "Eroare la oprirea LLM",
    "adminOnly": "Doar adminii pot porni LLM-ul (oprit explicit de admin)",
    "status": {
      "running": "Activ",
      "stopped_auto": "Inactiv / auto-sleep",
      "stopped_admin": "Oprit de admin"
    }
  },
  "hoaCharges": {
    "title": "Cheltuieli Întreținere",
    "subtitle": "Prezentare generală a cheltuielilor de întreținere",
    "totalCharges": "Total Cheltuieli",
    "unpaidTotal": "Total Neachitat",
    "ownerUnpaid": "Neachitat Proprietar",
    "renterUnpaid": "Neachitat Chiriaș",
    "charges": "cheltuieli",
    "filters": "Filtre",
    "allBuildings": "Toate Clădirile",
    "allStatuses": "Toate Statusurile",
    "allResponsible": "Toți Responsabilii",
    "unpaid": "Neachitat",
    "paid": "Achitat",
    "owner": "Proprietar",
    "renter": "Chiriaș",
    "buildingApartment": "Clădire / Apartament",
    "category": "Categorie",
    "period": "Perioadă",
    "amount": "Sumă",
    "responsible": "Responsabil",
    "status": "Status",
    "actions": "Acțiuni",
    "markPaid": "Marchează Achitat",
    "noCharges": "Nu s-au găsit cheltuieli de întreținere.",
    "markPaidSuccess": "Cheltuială marcată ca achitată",
    "markPaidError": "Eroare la marcarea cheltuielii ca achitată"
  },
  "apartmentToasts": {
    "deleted": "Apartament șters",
    "deleteFailed": "Eroare la ștergerea apartamentului",
    "taskCreated": "Sarcină creată",
    "taskCreateError": "Eroare la crearea sarcinii",
    "taskUpdateError": "Eroare la actualizarea sarcinii",
    "roleRemoved": "Rol eliminat",
    "roleRemoveFailed": "Eroare la eliminarea rolului",
    "legacyTenantRemoved": "Chiriaș vechi eliminat",
    "tenantRemoveFailed": "Eroare la eliminarea chiriașului",
    "tenantUpdated": "Chiriaș actualizat",
    "tenantUpdateFailed": "Eroare la actualizarea chiriașului",
    "tenantDeleteFailed": "Eroare la ștergerea chiriașului",
    "converted": "Convertit la entitate standard și atribuit ca chiriaș",
    "conversionFailed": "Conversie eșuată"
  },
  "financesToasts": {
    "holdingAdded": "Deținere adăugată",
    "holdingUpdated": "Deținere actualizată",
    "saveFailed": "Salvare eșuată",
    "holdingDeleted": "Deținere ștearsă",
    "deleteFailed": "Ștergere eșuată",
    "holdingMoved": "Deținere mutată",
    "tradevilleImportFailed": "Import Tradeville eșuat",
    "revolutImportFailed": "Import Revolut eșuat",
    "etoroImportFailed": "Import extras eToro eșuat",
    "binanceImportFailed": "Import Binance eșuat",
    "importWithErrors": "Importat cu erori: {{errors}}",
    "importSuccess": "{{created}} create, {{updated}} actualizate",
    "etoroSyncFailed": "Sincronizare API eToro eșuată",
    "priceUpdateWithErrors": "Actualizate {{updated}}, erori: {{errors}}",
    "pricesUpdated": "Prețuri actualizate: {{updated}} dețineri",
    "priceRefreshFailed": "Actualizare prețuri eșuată",
    "depositRecomputed": "Valori depozite recalculate: {{updated}}",
    "depositRecomputeFailed": "Recalculare depozite eșuată",
    "gfSyncWithErrors": "Sincronizat {{imported}}, erori: {{errors}}",
    "gfSyncSuccess": "Ghostfolio: {{imported}} activități importate",
    "gfSyncFailed": "Sincronizare Ghostfolio eșuată",
    "moveFailed": "Mutare eșuată"
  },
  "utilityToasts": {
    "markedPaid": "Marcat ca achitat",
    "markPaidFailed": "Eroare la marcarea ca achitat",
    "syncQueued": "Sincronizare programată",
    "syncFailed": "Sincronizare eșuată",
    "historicalPullQueued": "Descărcare istoric programată (2 ani de email + date portal)",
    "historyPullFailed": "Eroare la programarea descărcării istoricului",
    "readingSaved": "Citire salvată",
    "readingSaveFailed": "Eroare la salvarea citirii",
    "readingDeleteFailed": "Eroare la ștergerea citirii"
  },
  "bundlesToasts": {
    "created": "Pachet \"{{name}}\" creat",
    "createFailed": "Eroare la crearea pachetului",
    "createdWithDocs": "Pachet \"{{name}}\" creat cu documente",
    "createFromSuggestionFailed": "Eroare la crearea pachetului din sugestie",
    "deleted": "Pachet șters",
    "deleteFailed": "Eroare la ștergerea pachetului",
    "smartRefreshed": "Pachet inteligent actualizat: +{{added}} / -{{removed}} documente",
    "refreshFailed": "Eroare la actualizarea pachetului inteligent",
    "docsRemoved": "{{count}} document(e) eliminate din pachet",
    "removeFailed": "Eroare la eliminarea documentelor"
  },
  "documentsToasts": {
    "defaultProfileSet": "Profil implicit setat",
    "recommendFailed": "Eroare la generarea recomandărilor",
    "profileSaved": "Profil \"{{name}}\" salvat"
  },
  "career": {
    "profiles": {
      "label": "Profil candidat",
      "select": "Selectează un profil",
      "selectionRequired": "Alege un profil de candidat pentru a continua",
      "workingOn": "Lucrezi pe profilul {{name}}",
      "loadError": "Nu s-au putut încărca profilurile candidaților",
      "readOnly": "Acces doar pentru citire: poți vedea acest profil, dar nu îl poți modifica. Scanările, răspunsurile și alte modificări vor fi refuzate."
    },
    "djinni": {
      "notChecked": "Neverificat",
      "checking": "Se verifică…",
      "check": "Verifică Djinni",
      "verified": "Ultima verificare",
      "replied": "Angajatorul a răspuns",
      "awaiting": "Nu a fost găsit un răspuns de la angajator",
      "unclear": "Starea răspunsului este neclară",
      "open": "Deschide conversația",
      "reauth": "Autentificarea Djinni trebuie reînnoită. Starea salvată este păstrată.",
      "failed": "Ultima stare nu a putut fi verificată. Starea salvată este păstrată."
    },
    "title": "Panou Carieră",
    "subtitle": "Pipeline căutare job, oferte & evaluări",
    "bridgeOnline": "Bridge online",
    "bridgeOffline": "Bridge offline",
    "bridgeChecking": "Se verifică bridge-ul…",
    "bridgeNoAccess": "Fără acces la un profil Career",
    "tabs": {
      "tracker": "Tracker",
      "pipeline": "Pipeline",
      "reports": "Rapoarte",
      "scanner": "Scanner",
      "liveness": "Disponibilitate",
      "questions": "Întrebări"
    },
    "tracker": {
      "failedToLoad": "Nu s-a putut încărca tracker-ul",
      "applicationCount": "{{count}} aplicații",
      "applicationCountFiltered": "{{filtered}} din {{total}} aplicații",
      "refresh": "Reîmprospătare",
      "searchPlaceholder": "Caută companie, rol...",
      "allPlatforms": "Toate platformele",
      "allStatuses": "Toate statusurile",
      "minScore": "Scor minim:",
      "clearFilters": "Șterge",
      "colNumber": "#",
      "colDate": "Data",
      "colCompany": "Companie",
      "colRole": "Rol",
      "colPlatform": "Platformă",
      "colScore": "Scor",
      "colStatus": "Status",
      "colPdf": "PDF",
      "colReport": "Raport",
      "colNotes": "Notițe",
      "noMatchingApps": "Nicio aplicație nu se potrivește filtrelor",
      "noAppsYet": "Nicio aplicație încă",
      "allPdfStatus": "Toate PDF",
      "hasPdf": "Are PDF ✅",
      "noPdf": "Fără PDF ❌",
      "openPdf": "Descarcă CV generat",
      "pdfFailed": "CV-ul nu a putut fi descărcat. Încearcă din nou."
    },
    "pipeline": {
      "failedToLoad": "Nu s-a putut încărca pipeline-ul",
      "title": "Inbox Pipeline",
      "noPendingUrls": "Niciun URL în așteptare"
    },
    "reports": {
      "reportCount": "{{count}} Rapoarte",
      "emptyReport": "Raport gol",
      "selectReport": "Selectează un raport pentru vizualizare"
    },
    "scanner": {
      "title": "Scanner Portaluri",
      "quickScan": "Scanare rapidă",
      "fullScan": "Scanare completă",
      "scanning": "Scanare portaluri... poate dura câteva minute"
    },
    "batch": {
      "title": "Evaluare lot",
      "running": "(Rulează)",
      "complete": "(Complet)",
      "paused": "(Pauză)",
      "doneCount": "{{completed}}/{{total}} gata · {{failed}} eșuate · medie {{avg}}",
      "topScores": "Scoruri top:"
    },
    "liveness": {
      "title": "Verificare Disponibilitate Posturi",
      "urlsLabel": "URL-uri postări job (unul pe linie)",
      "checkBtn": "Verifică Disponibilitate",
      "loadTracker": "Încarcă din Tracker",
      "useOllama": "Folosește Ollama pentru incerte",
      "checking": "Verificare URL-uri... poate dura pentru loturi mari.",
      "checkFailed": "Verificare disponibilitate eșuată",
      "noUrls": "Introduceți cel puțin un URL",
      "colStatus": "Status",
      "colUrl": "URL"
    },
    "questions": {
      "title": "Întrebări Competențe",
      "subtitle": "Răspunde la întrebări pentru a îmbunătăți acuratețea CV-ului",
      "queue": "Coadă Prioritară",
      "allQuestions": "Toate Întrebările",
      "stats": "{{answered}} din {{total}} răspunse",
      "noQuestions": "Nicio întrebare încă. Întrebările vor apărea aici când generarea CV-ului întâmpină competențe incerte.",
      "noUnanswered": "Toate întrebările au primit răspuns! Profilul tău este complet calibrat.",
      "category": "Categorie",
      "allCategories": "Toate Categoriile",
      "answered": "Răspunse",
      "unanswered": "Nerăspunse",
      "all": "Toate",
      "answerPlaceholder": "Scrie răspunsul...",
      "confidenceLabel": "Încredere (1-5)",
      "submit": "Trimite Răspuns",
      "submitting": "Se trimite...",
      "positions": "{{count}} poziții",
      "answerSuccess": "Răspuns salvat cu succes",
      "answerError": "Eroare la salvarea răspunsului",
      "loadError": "Nu s-au putut încărca întrebările",
      "loading": "Se încarcă întrebările...",
      "noPositionQuestions": "Nicio întrebare pentru {{company}} — {{role}}",
      "positionQuestions": "{{count}} întrebări pentru {{company}} — {{role}}",
      "yourAnswer": "Răspunsul tău",
      "editAnswer": "Editează",
      "calibrated": "Calibrat",
      "pending": "Calibrare în așteptare"
    },
    "retry": "Reîncearcă"
  },
  "careerToasts": {
    "scanCompleted": "Scanare finalizată",
    "scanFailed": "Scanare eșuată"
  },
  "settingsToasts": {
    "disconnectFailed": "Nu s-a putut deconecta"
  },
  "history": {
    "filterAll": "Toate",
    "filterOccupation": "Ocupare",
    "filterMoney": "Bani",
    "filterMaintenance": "Întreținere",
    "filterTasks": "Sarcini",
    "dateRange6mo": "6 luni",
    "dateRange1yr": "1 an",
    "dateRange2yr": "2 ani",
    "dateRangeAll": "Tot",
    "apartmentLabel": "Apartament:",
    "noEvents": "Niciun eveniment nu corespunde filtrelor curente",
    "noEventsHint": "Încercați să ajustați filtrele de categorie sau interval de date.",
    "present": "prezent",
    "budgetPrefix": "Buget:",
    "paymentRent": "Chirie",
    "paymentDeposit": "Garanție",
    "paymentUtilities": "Utilități",
    "paymentMaintenance": "Întreținere",
    "paymentRepair": "Reparație",
    "paymentOther": "Plată"
  },
  "utility": {
    "noInvoice": "Fără factură",
    "paid": "Plătit",
    "overdue": "Restant",
    "dueInDays": "Scadent în {{days}}z",
    "dueDate": "Scadent {{date}}",
    "loading": "Se încarcă conturile de utilități…",
    "noAccounts": "Niciun cont de utilități configurat pentru acest apartament.",
    "noAccountsHint": "Adăugați-le prin Admin → Proprietăți → Conturi utilități.",
    "type": {
      "electricity": "Electricitate",
      "gas": "Gaz",
      "water": "Apă",
      "internet": "Internet",
      "maintenance": "Întreținere",
      "insurance": "Asigurare",
      "tax": "Taxe",
      "other": "Altele"
    },
    "status": {
      "cancelled": "Anulat",
      "paid": "Plătit",
      "overdueDays": "Întârziere {{days}}z",
      "graceDays": "Grație {{days}}z rămase",
      "dueInDays": "Scadent în {{days}}z"
    },
    "summary": {
      "allTime": "toate facturile",
      "gracePeriod": "Perioadă de grație",
      "inGraceWindow": "încă în perioada de grație",
      "invoiceCount": "{{count}} facturi",
      "overdue": "Întârziate",
      "pastDue": "facturi restante",
      "pendingLabel": "În așteptare (RON)",
      "total": "Total"
    },
    "table": {
      "amount": "Sumă",
      "provider": "Furnizor / Perioadă",
      "status": "Stare",
      "type": "Tip"
    },
    "breakdown": {
      "invoiceCount": "{{count}} factură(i)",
      "overdueCount": "{{count}} restante",
      "pending": "în așteptare",
      "title": "Defalcare pe apartament"
    },
    "accounts": {
      "addAccount": "+ Adaugă cont prin Admin",
      "addViaAdmin": "Adaugă prin Admin",
      "noneConfigured": "Niciun cont de utilități configurat.",
      "pullHistory": "Preia istoric",
      "sync": "Sincronizare",
      "title": "Conturi utilități"
    },
    "readings": {
      "noReadings": "Nicio citire încă",
      "sent": "Trimis",
      "submittedToProvider": "Transmis furnizorului",
      "title": "Citiri"
    },
    "action": {
      "markPaid": "Marchează plătit",
      "paidCheck": "Plătit ✓",
      "viewPdf": "Vezi PDF"
    },
    "loadFailed": "Încărcarea datelor de utilități a eșuat. Reîmprospătați.",
    "loadingBills": "Se încarcă facturile de utilități…",
    "monthlyHistory": "Istoric costuri lunare",
    "noHistoryData": "Nicio factură încă. Preia istoricul pentru a popula.",
    "noInvoices": "Nicio factură.",
    "noInvoicesForType": "Nicio factură pentru {{type}}."
  },
  "rentDue": {
    "nth1st": "Prima",
    "nth2nd": "A doua",
    "nth3rd": "A treia",
    "nth4th": "A patra",
    "nthLast": "Ultima",
    "monday": "Luni",
    "tuesday": "Marți",
    "wednesday": "Miercuri",
    "thursday": "Joi",
    "friday": "Vineri",
    "saturday": "Sâmbătă",
    "sunday": "Duminică",
    "dayOfMonth": "Ziua din lună",
    "nthWeekday": "A N-a zi a săptămânii",
    "dayHelper": "Ziua din lună (1–28)"
  },
  "apartmentDetail": {
    "activeMaintenanceCount": "{{count}} lucrări de întreținere active pentru {{building}}.",
    "addEntry": "Adaugă înregistrare",
    "apartmentDetails": "Detalii apartament",
    "bathrooms": "Băi",
    "building": "Clădire",
    "buildingMaintenanceInProgress": "Lucrări de întreținere în desfășurare",
    "confirmConvertLegacyTenant": "Convertiți acest chiriaș legacy într-o entitate Identity standard?\n\nAcest lucru va:\n• Crea o nouă entitate Persoană cu datele curente\n• Atribui rolul de Chiriaș pentru acest apartament\n• Elimina înregistrarea de chiriaș legacy",
    "confirmDelete": "Ștergeți \"{{name}}\"? Această acțiune nu poate fi anulată.",
    "confirmDeleteLegacyTenant": "Ștergeți permanent această înregistrare de chiriaș legacy?",
    "confirmRemoveLegacyTenant": "Eliminați chiriașul legacy \"{{name}}\"?",
    "confirmRemoveRole": "Eliminați această atribuire de rol?",
    "contractEnd": "Sfârșit contract",
    "contractType": "Tip contract",
    "convertToEntity": "Convertește în entitate",
    "convertToEntityTooltip": "Creează o entitate Identity din acest chiriaș legacy și atribuie rolul de Chiriaș",
    "deleteApartment": "Șterge apartamentul",
    "deposit": "Garanție",
    "documentsWillAppear": "Documentele atribuite acestui apartament vor apărea aici.",
    "dueDate": "scadent {{date}}",
    "editLegacyTenant": "Editează chiriaș legacy",
    "editLegacyTenantTitle": "Editare chiriaș legacy",
    "editRoles": "Editează roluri",
    "email": "Email",
    "firstName": "Prenume",
    "floor": "Etaj",
    "floorLabel": "Etaj",
    "furnished": "Mobilat",
    "goToDocuments": "Mergi la Documente",
    "lastName": "Nume",
    "linkedPeople": "Persoane asociate",
    "monthlyRent": "Chirie lunară",
    "moreItems": "+ încă {{count}}",
    "moveInDate": "Data mutării",
    "moveOutDate": "Data plecării",
    "newTaskEntry": "Sarcină nouă / Înregistrare întreținere",
    "noDocumentsLinked": "Niciun document asociat",
    "noLinkedPeople": "Nicio persoană asociată",
    "noMaintenanceEntries": "Nicio înregistrare de întreținere pentru acest apartament",
    "noTasks": "Nicio sarcină pentru acest apartament",
    "notes": "Note",
    "notesLabel": "Note",
    "parking": "Parcare",
    "permanentAddress": "Adresă permanentă",
    "phone": "Telefon",
    "removeLegacyTenant": "Elimină chiriaș legacy",
    "rentalStart": "Început închiriere",
    "rentDueDay": "Ziua scadenței chiriei",
    "rooms": "Camere",
    "scheduledMaintenanceCount": "{{count}} lucrări de întreținere programate pentru {{building}}.",
    "secondaryPhone": "Telefon secundar",
    "statMaintenanceBudget": "Buget întreținere",
    "statMonthlyRent": "Chirie lunară",
    "statOpenMaintenance": "Întreținere deschisă",
    "statStatus": "Stare",
    "statusLabel": "Stare",
    "storage": "Boxă",
    "surface": "Suprafață",
    "tenantLegacy": "chiriaș (legacy)",
    "theBuilding": "clădirea",
    "totalCount": "{{count}} total",
    "upcomingBuildingMaintenance": "Întreținere clădire programată",
    "viewBuildingMaintenance": "Vezi întreținere clădire →"
  },
  "finances": {
    "addManualHolding": "Adaugă deținere manuală",
    "addManually": "Adaugă manual",
    "all": "Toate",
    "apiBearerToken": "Token API bearer",
    "autoInterest": "Auto (dobândă)",
    "avgCost": "Cost mediu",
    "binanceCsv": "Binance CSV istoric tranzacții",
    "binanceDesc": "Exportă din Binance: Comenzi → Istoric tranzacții → Export. Deținerile nete crypto sunt calculate din istoricul de cumpărare/vânzare.",
    "chooseBinanceFile": "Alege fișierul Binance",
    "chooseEtoroFile": "Alege extrasul eToro (.xlsx / .csv)",
    "chooseRevolutFile": "Alege fișierul Revolut",
    "chooseTradevilleFile": "Alege fișierul Tradeville",
    "computed": "calculat",
    "confirmDelete": "Ștergeți {{symbol}}?",
    "currency": "Monedă",
    "currentPrice": "Preț curent",
    "deposits": "Depozite",
    "displayName": "Nume afișat",
    "editHolding": "Editare — {{symbol}}",
    "etoroApiKeyPlaceholder": "x-api-key (Cheie API publică)",
    "etoroKeyMgmt": "în eToro → Setări → Tranzacționare → Gestionare chei API.",
    "etoroLiveSync": "Sincronizare live eToro",
    "etoroLiveSyncDesc": "Sincronizează portofoliul live direct din API-ul eToro.",
    "etoroStatement": "Extras de cont eToro",
    "etoroStatementDesc": "Descarcă din eToro: Portofoliu → Istoric → Extras de cont → Descarcă. Folosește intervalul complet. Încarcă fișierul .xlsx sau .csv.",
    "etoroUserKeyPlaceholder": "x-user-key (Cheie utilizator)",
    "family": "Familie",
    "familyValue": "Valoare familie",
    "fetchingAuthToken": "Se obține token-ul de autentificare…",
    "generateKeys": "Generează chei",
    "ghostfolioDesc": "Trimite deținerile din vizualizarea activă a portofoliului către instanța Ghostfolio ca activități MANUAL BUY.",
    "ghostfolioSync": "Sincronizare Ghostfolio",
    "ghostfolioTokenPlaceholder": "Token de securitate Ghostfolio",
    "ghostfolioUrl": "URL Ghostfolio",
    "holdingsAcrossPortfolios": "{{count}} dețineri în {{portfolios}} portofolii",
    "holdingsCount": "{{count}} dețineri",
    "importErrors": "Erori de import",
    "importSync": "Import / Sincronizare",
    "importTitle": "Import — {{name}}",
    "interestAccrual": "Acumulare dobândă (calculează automat valoarea curentă)",
    "isin": "ISIN",
    "isinPlaceholder": "ex. RO9P01XXG005",
    "maturity": "Scadență",
    "moveToAnotherPortfolio": "Mută în alt portofoliu",
    "name": "Nume",
    "noHoldingsYet": "Nicio deținere încă. Importă un CSV sau sincronizează din eToro.",
    "noPortfoliosDesc": "Adaugă un portofoliu prin Django admin sau API, apoi importă deținerile.",
    "noPortfoliosYet": "Niciun portofoliu încă",
    "notes": "Note",
    "openGhostfolio": "Deschide Ghostfolio",
    "personal": "Personal",
    "personalValue": "Valoare personală",
    "plPct": "P/P %",
    "price": "Preț",
    "prices": "Prețuri",
    "profitLossPct": "Profit/Pierdere %",
    "profitLossTab": "Profit/Pierdere ({{tab}})",
    "qty": "Cant.",
    "quantityRequired": "Cantitate *",
    "ratePerYear": "Rată % / an",
    "ratePlaceholder": "ex. 7.5",
    "recomputeDepositsTitle": "Recalculează valorile acumulate ale depozitelor/obligațiunilor",
    "refreshPricesTitle": "Actualizează prețurile de piață prin Yahoo Finance",
    "rememberInBrowser": "Memorează în browser",
    "rememberKeys": "Memorează cheile în acest browser (localStorage)",
    "revolutCsv": "Revolut Stocks CSV",
    "revolutDesc": "Istoric tranzacții din Revolut (Profil → Extrase → Revolut Stocks). Pozițiile nete sunt calculate automat.",
    "selectPortfolio": "Selectează portofoliu…",
    "source": "Sursă",
    "startDate": "Data de început",
    "symbol": "Simbol",
    "symbolFilterPlaceholder": "Filtru simbol (separate prin virgulă, opțional)",
    "symbolPlaceholder": "ex. TVBETETF",
    "symbolRequired": "Simbol *",
    "syncFromEtoroApi": "Sincronizează din API-ul eToro",
    "syncToGhostfolio": "Sincronizează {{count}} portofoliu(ii) cu Ghostfolio",
    "totalValue": "Valoare totală",
    "tradevilleCsv": "Tradeville CSV",
    "tradevilleDesc": "CSV snapshot din Tradeville. Folosește \"Filtru simbol\" pentru a importa doar simboluri specifice (ex. TVBETETF pentru Personal, R3202A pentru Familie).",
    "type": "Tip",
    "value": "Valoare"
  },
  "apartment": {
    "notFound": "Apartamentul nu a fost găsit"
  },
  "knowledge": {
    "title": "Cunoștințe",
    "subtitle": "Creier de familie și personal",
    "familyBrain": "Creier familie",
    "myBrain": "Creierul meu",
    "searchNotes": "Caută note…",
    "newNote": "Notă nouă",
    "noNotes": "Nicio notă încă",
    "selectOrCreate": "Selectează o notă sau creează una nouă",
    "noteTitle": "Titlu notă",
    "markdownPlaceholder": "Scrie markdown…",
    "tags": "Etichete",
    "addTag": "Adaugă etichetă…",
    "backlinks": "Legături inverse",
    "noBacklinks": "Nicio entitate legată",
    "daily": "zilnic",
    "edit": "Editare",
    "preview": "Previzualizare",
    "emptyBody": "Notă goală",
    "unsaved": "Modificări nesalvate",
    "untitled": "Fără titlu",
    "noteCreated": "Notă creată",
    "noteSaved": "Notă salvată",
    "noteDeleted": "Notă ștearsă",
    "saveError": "Salvare eșuată",
    "deleteError": "Ștergere eșuată",
    "deleteConfirm": "Ștergi definitiv această notă?",
    "familyReadOnly": "Notele familiei sunt doar citire pentru non-admini",
    "openTodayDaily": "Deschide nota zilnică de azi",
    "createTodayDaily": "Creează nota zilnică de azi",
    "searchAll": "Caută note și documente…",
    "searchMode": {
      "text": "Text",
      "semantic": "Semantic",
      "hybrid": "Hibrid"
    },
    "noSearchResults": "Niciun rezultat",
    "hitDocument": "doc",
    "hitNote": "notă",
    "searchSettings": "Setări căutare",
    "searchSettingsSaved": "Setările de căutare au fost salvate",
    "searchSettingsError": "Salvarea setărilor de căutare a eșuat",
    "includeDocuments": "Include documente",
    "includeDocumentsHelp": "Caută documente de familie în rezultatele unificate",
    "includeCareer": "Include note carieră",
    "includeCareerHelp": "Include notele personale career-ops în căutarea unificată"
  }
}
